<template>
  <div class="left-chart-wrapper" v-loading="pending">
    <div id="left-chart"></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    pending: {
      type: Boolean,
      default: true
    },
    leftPieLabelData: {
      type: Array
    }
  },
  watch: {
    pending () {
      this.drawChart()
    }
  },
  methods: {
    drawChart () {
      if (this.pending) {
        return
      }
      const myLineChar = this.$echarts.init(document.getElementById('left-chart'))
      myLineChar.setOption({
        color: ['#EC3D08', '#4A5B6D', '#221974'],
        title: {
          text: '调用次数统计',
          textStyle: {
            color: '#3D3D3D',
            fontSize: 14
          },
          left: 24,
          top: 24
        },
        legend: {
          bottom: '15',
          // right: 0,
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 30,
          data: this.leftPieLabelData
        },
        series: [
          {
            center: ['50%', '40%'],
            name: '调用次数统计',
            type: 'pie',
            radius: ['25%', '40%'],
            avoidLabelOverlap: true,
            label: {
              show: true,
              formatter: '{b}:  {c}'
            },
            labelLine: {
              show: false
            },
            data: this.data
          }
        ]
      })
      myLineChar.resize()
    }
  },
  mounted () {
    this.drawChart()
    window.addEventListener('resize', this.drawChart)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.drawChart)
    })
  }
}
</script>

<style lang="scss" scoped>
.left-chart-wrapper {
  height: 323px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(17, 39, 98, 0.04);
  border-radius: 4px;
  width: 49%;
  #left-chart {
    width: 100%;
    height: 100%;
  }
}
</style>